/*
 * strova scratcher
 * Wird nur geladen, wenn die Section rendert — also nur bei aktivem, echtem Rabatt.
 * Speichert ausschliesslich den Kategoriewert, keine personenbezogenen Daten.
 * Rabattlogik und Speicherschluessel sind nicht im Theme Editor editierbar.
 *
 * Testen ohne Warten:
 *   1. Checkbox "Testmodus" in der Sektion — ignoriert Cooldown und eingeloesten Status.
 *   2. URL-Parameter ?strova-scratcher=reset — loescht den gespeicherten Zustand einmalig.
 *      ?strova-scratcher=test — ignoriert den Zustand nur fuer diesen Aufruf.
 *   3. Konsole: strova.resetScratcher()  — loescht den Zustand und laedt neu.
 *   4. Im Theme Editor ist der Cooldown grundsaetzlich ausgesetzt.
 */
(function () {
  'use strict';

  var strova = (window.strova = window.strova || {});

  var KEY_ANSWER = 'strova_quiz_answer';
  var KEY_STATE = 'strova_scratch_state';
  var KEY_REWARD = 'strova_reward_id';
  var KEY_SEEN = 'strova_seen_at';
  var ALL_KEYS = [KEY_ANSWER, KEY_ANSWER + '_handle', KEY_STATE, KEY_REWARD, KEY_SEEN];

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (error) {
      return null;
    }
  }

  function clearState() {
    ALL_KEYS.forEach(function (key) {
      try { window.localStorage.removeItem(key); } catch (error) { /* Private Mode */ }
    });
  }

  /* Auch verfuegbar, wenn das Modul auf dieser Seite gar nicht rendert. */
  strova.resetScratcher = function (reload) {
    clearState();
    if (reload !== false) window.location.reload();
    return true;
  };

  var root = document.querySelector('[data-st-scratcher]');
  if (!root) return;

  var flag = '';
  try {
    flag = new URLSearchParams(window.location.search).get('strova-scratcher') || '';
  } catch (error) {
    flag = '';
  }
  if (flag === 'reset') clearState();

  var testMode =
    root.dataset.testMode === 'true' ||
    root.dataset.designMode === 'true' ||
    flag === 'test' ||
    flag === 'reset';

  var rewardId = root.dataset.rewardId;
  var cooldownDays = parseInt(root.dataset.cooldownDays, 10) || 0;
  var threshold = (parseInt(root.dataset.threshold, 10) || 55) / 100;
  var isDesktop = window.matchMedia('(min-width: 990px)').matches;

  if (isDesktop && root.dataset.desktop !== 'true') return;
  if (!isDesktop && root.dataset.mobile !== 'true') return;

  if (!testMode) {
    var seenAt = parseInt(store(KEY_SEEN), 10);
    if (seenAt && cooldownDays > 0) {
      var elapsedDays = (Date.now() - seenAt) / 86400000;
      if (elapsedDays < cooldownDays) return;
    }
    if (store(KEY_STATE) === 'claimed' && store(KEY_REWARD) === rewardId) return;
  }

  var quizStep = root.querySelector('[data-st-step="quiz"]');
  var scratchStep = root.querySelector('[data-st-step="scratch"]');
  var area = root.querySelector('[data-st-scratch-area]');
  var canvas = root.querySelector('[data-st-scratch-canvas]');
  var revealButton = root.querySelector('[data-st-scratch-reveal]');
  var actions = root.querySelector('[data-st-reward-actions]');
  var recos = root.querySelector('[data-st-recos]');
  var hint = root.querySelector('[data-st-scratch-hint]');
  var dataNode = root.querySelector('[data-st-quiz-data]');
  var quizData = { answers: [] };

  try {
    quizData = JSON.parse(dataNode.textContent);
  } catch (error) {
    quizData = { answers: [] };
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var layer = null;

  function close() {
    if (strova.closeLayer) strova.closeLayer(layer);
    layer = null;
    store(KEY_SEEN, String(Date.now()));
  }

  root.querySelectorAll('[data-st-scratcher-close]').forEach(function (button) {
    button.addEventListener('click', close);
  });

  function open() {
    if (!strova.openLayer) return;
    layer = strova.openLayer(root, 'is-open');
    store(KEY_SEEN, String(Date.now()));
    if (strova.track) strova.track('strova_quiz_view', {});
  }

  function showRecommendations(handle) {
    if (!recos) return;
    var entry = quizData.answers.filter(function (answer) {
      return answer.handle === handle;
    })[0];
    if (!entry || !entry.products || !entry.products.length) return;

    recos.innerHTML = entry.products
      .map(function (product, index) {
        var image = product.image
          ? '<span class="st-card__media"><img src="' + product.image + '" alt="" loading="lazy"></span>'
          : '';
        return (
          '<a class="st-card" href="' + product.url + '" data-position="' + index + '">' +
          image +
          '<span class="st-card__title" style="font-size:14px">' + product.title + '</span></a>'
        );
      })
      .join('');
    recos.hidden = false;

    recos.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        if (strova.track) {
          strova.track('strova_recommendation_click', { position: link.dataset.position, url: link.getAttribute('href') });
        }
      });
    });
  }

  function reveal() {
    if (area.classList.contains('is-revealed')) return;
    area.classList.add('is-revealed');
    if (actions) actions.hidden = false;
    if (revealButton) revealButton.hidden = true;
    if (hint) hint.hidden = true;
    store(KEY_STATE, 'revealed');
    store(KEY_REWARD, rewardId);
    if (strova.track) strova.track('strova_scratch_complete', { reward_id: rewardId });
    showRecommendations(store(KEY_ANSWER + '_handle') || '');
  }

  function initCanvas() {
    if (!canvas || reducedMotion) {
      reveal();
      return;
    }

    var rect = area.getBoundingClientRect();
    var ratio = window.devicePixelRatio || 1;
    canvas.width = rect.width * ratio;
    canvas.height = rect.height * ratio;
    var context = canvas.getContext('2d');
    context.scale(ratio, ratio);
    context.fillStyle = '#e4e0da';
    context.fillRect(0, 0, rect.width, rect.height);
    context.globalCompositeOperation = 'destination-out';

    var drawing = false;
    var started = false;

    function point(event) {
      var bounds = canvas.getBoundingClientRect();
      return { x: event.clientX - bounds.left, y: event.clientY - bounds.top };
    }

    function scratch(event) {
      if (!drawing) return;
      var position = point(event);
      context.beginPath();
      context.arc(position.x, position.y, 22, 0, Math.PI * 2);
      context.fill();
    }

    function cleared() {
      var image = context.getImageData(0, 0, canvas.width, canvas.height).data;
      var transparent = 0;
      var samples = 0;
      for (var i = 3; i < image.length; i += 4 * 64) {
        samples++;
        if (image[i] < 24) transparent++;
      }
      return samples ? transparent / samples : 0;
    }

    canvas.addEventListener('pointerdown', function (event) {
      drawing = true;
      canvas.setPointerCapture(event.pointerId);
      if (!started) {
        started = true;
        if (strova.track) strova.track('strova_scratch_start', { reward_id: rewardId });
      }
      scratch(event);
    });
    canvas.addEventListener('pointermove', scratch);
    canvas.addEventListener('pointerup', function () {
      drawing = false;
      if (cleared() >= threshold) reveal();
    });
    canvas.addEventListener('pointercancel', function () {
      drawing = false;
    });
  }

  root.querySelectorAll('[data-st-quiz-answer]').forEach(function (input) {
    input.addEventListener('change', function () {
      store(KEY_ANSWER, input.value);
      store(KEY_ANSWER + '_handle', input.dataset.handle);
      if (strova.track) strova.track('strova_quiz_answer', { interest_category: input.value });
      quizStep.hidden = true;
      scratchStep.hidden = false;
      if (strova.track) strova.track('strova_scratch_view', { reward_id: rewardId });
      window.requestAnimationFrame(initCanvas);
    });
  });

  if (revealButton) revealButton.addEventListener('click', reveal);

  var claim = root.querySelector('[data-st-reward-claim]');
  if (claim) {
    claim.addEventListener('click', function () {
      store(KEY_STATE, 'claimed');
      if (strova.track) strova.track('strova_discount_claim', { reward_id: rewardId });
    });
  }

  var delay = (parseInt(root.dataset.delay, 10) || 0) * 1000;
  window.setTimeout(open, delay);
})();
